import styled from 'styled-components';

const Contenedor = styled.div`
  .logo {
    background-color: #f42534;
  }

  .CardBase {
    box-shadow: 0 0 8px 0 rgb(0 0 0 / 14%);
  }

  .CardBase h2 {
    font-size: 18px;
  }
  
  .cabecera-webpay-coopeuch img {
    padding: 22px;
  }
  .formulario-login-coopeuch header {
    padding: 15px 32px;
}
  .contenedor-imagenes-wepbay img {
    width: 152px;
    padding: 4px 0 10px 10px;
  }
  .body-webpay-coopeuch {
    background-color: #fbfbfb;
  }
  .contenedor-imagenes-wepbay {
    display: flex;
    margin: 0 auto;
    padding-top: 16px;
    justify-content: center;
    align-items: center;
    height: 90px;
  }

  form.formulario-webpay-login label:nth-child(2) {
    padding-top: 18px;
}

  .formulario-login-coopeuch {
    max-width: 450px;
    margin: 0 auto;
    padding-bottom: 25px;
    padding: 15px;
  }

  .subtitulo-formulario {
    line-height: 16px;
    color: #333333;
    font-weight: 400;
    padding-bottom: 15px;
  }

  form.formulario-webpay-login input {
    border-radius: 7px;
  }
  form.formulario-webpay-login label {
    display: block;
    margin-top: 15px;
    color: #383638;
    font-weight: bold;
    position:relative;
  }

  form.formulario-webpay-login label input {
    display: block;
    width: 100%;
    height: 48px;
  }

  input#rut-login-coopeuch {
    background-color: #f4f4f4;
    border: 1px solid #9c9a9f;
    margin-top: 7px;
    padding: 10px;
    color: #9C9A9F;
    font-weight: 400;
  }
  input#clave-login-coopeuch {
    margin-top: 7px;
    border: 1px solid #646569;
    padding: 0 30px 0 30px;
    color: #646569;
    font-weight: 400;
  }
  .candado-login {
    width: 12px;
    height: 15px;
    display: block;
    position: absolute;
    top: 63px;
    left: 10px;
  }
  .ojo-login {
    width: 24px;
    display: block;
    position: absolute;
    top: 57px;
    right: 19px;
    cursor: pointer;
}

  form.formulario-webpay-login button {
    width: 100%;
    margin-top: 20px;
  }
  .contenedor-informacion-login {
    background-color: #c0e9fd;
    padding: 20px;
    margin-top: 25px;
    margin-bottom: 25px;
  }
  .contenedor-informacion-login p {
    margin-left: 22px;
    color: #007DB7;
    font-size: 12px;
    line-height: 11px;
    margin-left: 22px;
}
p.strong {
  font-size: 12px !important;
  font-weight: bold;
  margin-bottom: 12px;
}
.contenedor-informacion-login p strong {
  font-size: 12px;
}

  span.errorGenerico {
    font-size: 1.8vh;
    color: #e83333;
    padding-left: 3px;
    display: block;
    margin-top: 7px;
}

span.ojo-login img {
  filter: none;
}

span.candado-login IMG {
  filter: none;
}
.contenedor-informacion-login img {
  filter: none;
  margin-right: 10px;
  position: absolute;
}

@media (max-width: 426px){
    .cabecera-webpay-coopeuch img {
      padding: 16px;
      width: 150px; 
  }
  .CardBase h2 {
    font-size: 16px;
  }

  p.strong {
    margin-bottom: 6px;
    font-size: 11px !important;
  }

  .subtitulo-formulario{
    font-size: 13px;
  }
  .contenedor-informacion-login p{
    font-size: 11px;
  }
  .contenedor-informacion-login p strong {
    font-size: 11px;
  }
  form.formulario-webpay-login label, form.formulario-webpay-login button{
  font-size: 13px;
  }
  .cabecera-webpay-coopeuch img {
    padding: 14px;
    width: 145px;
  }
  .cabecera-webpay-coopeuch img:nth-child(1) {
    padding-right: 4px;
  }
  .cabecera-webpay-coopeuch img:nth-child(2) {
    padding-left: 4px;
  }
  .ojo-login{
    top: 53px;
  }
  span.ojo-login img{
    padding: 1px;
  }
  .candado-login {
    top: 60px;
  }
  form.formulario-webpay-login label input{
    height: 44px;
  }

}

@media (max-width: 376px){
  .CardBase h2 {
    font-size: 17px;
  }

  p.strong {
    margin-bottom: 6px;
    font-size: 10px !important;
  }

  .subtitulo-formulario{
    font-size: 13px;
  }
  .contenedor-informacion-login p{
    font-size: 11px;
  }
  .contenedor-informacion-login p strong {
    font-size: 11px;
  }
  form.formulario-webpay-login label, form.formulario-webpay-login button{
  font-size: 13px;
  }
  .cabecera-webpay-coopeuch img {
    padding: 14px;
    width: 145px;
  }
  .cabecera-webpay-coopeuch img:nth-child(1) {
    padding-right: 4px;
  }
  .cabecera-webpay-coopeuch img:nth-child(2) {
    padding-left: 4px;
  }
  .ojo-login{
    top: 53px;
  }
  span.ojo-login img{
    padding: 1px;
  }
  .candado-login {
    top: 60px;
  }
  form.formulario-webpay-login label input{
    height: 44px;
  }
}

@media (max-width: 321px){
  .subtitulo-formulario, form.formulario-webpay-login label, .CardBase *, form.formulario-webpay-login button {
    font-size: 13px;
  }
  span.ojo-login img{
    padding: 2px;
  }
    .CardBase h2 {
      font-size: 16px;
  }
  .cabecera-webpay-coopeuch img:nth-child(1){
    padding-right: 0px;
  }
  .cabecera-webpay-coopeuch img:nth-child(2){
    padding-left: 0px;
  }
  .cabecera-webpay-coopeuch img {
    width: 130px;
  }
  .ojo-login {
    top: 53px;
  }
  .candado-login {
    top: 60px;
  }
  span.ojo-login img {
    padding: 2px;
  }
  form.formulario-webpay-login label input{
    height: 44px;
  }
}

`;

export default Contenedor;


